import RequiredValidator from "@/validators/RequiredValidator";

export default class AttachmentRules {

	public static readonly fileRules = [
		(new RequiredValidator('uiTerms.selectImageFile')).validationRule(),
	];

}
